var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLdevpDev = function SvgLdevpDev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "377.888 208.925 20.663 22.805"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M378.843 222.683c-.427-.218-.533-.537-.852-.966-.317-.957.113-1.797 1.076-2.1l6.736-2.115-2.114-6.383c-.317-.958.113-1.797 1.075-2.1.963-.302 1.816.135 2.133 1.093l2.642 7.979c.318.957-.113 1.797-1.075 2.1l-8.34 2.618c-.534-.008-1.068-.016-1.281-.126zM396.115 231.53l-8.103-4.15c-.853-.437-1.17-1.395-.74-2.234.43-.84 1.392-1.142 2.245-.705l8.104 4.15c.853.437 1.17 1.394.74 2.234-.43.84-1.393 1.142-2.246.705z",
    fill: "#F9D24B"
  })));
};
export default SvgLdevpDev;